export default "__VITE_ASSET__5swCPZl6__"